import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Flex from 'components/Flex'
import IconTick from 'components/Icons/IconTick'
import { colors, borderRadius, borderRadiusSizes } from 'theme/default'

const CheckboxContainer = styled(Flex).attrs(
  () => ({ alignItems: 'center' })
)`
  ${props => props.disabled ? '' : 'cursor: pointer;'}
`

const HiddenInput = styled.input.attrs(
  () => ({ type: 'checkbox' })
)`
  opacity: 0;
  position: absolute;
  pointer-events: none;
`

const TickContainer = styled(Flex).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 'small',
  role: 'checkbox'
}))`
  height: 25px;
  width: 25px;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 2px ${props => props.color ? props.color : props.theme.buttonColor};
  border-radius: ${borderRadius[borderRadiusSizes.small]};
  ${props => props.disabled ? 'opacity: 0.5;' : ''}
`

TickContainer.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary
  }
}

const StyledIconTick = styled(IconTick).attrs(
  (props) => ({
    height: 16,
    width: 16,
    fill: props.checked ? (props.disabled ? colors.disabled : props.theme.buttonColor) : 'none'
  })
)``
StyledIconTick.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary
  }
}

const TickBox = ({ checked, disabled, ...props }) => (
  <TickContainer disabled={disabled} {...props}>
    <StyledIconTick checked={checked} disabled={disabled} />
  </TickContainer>
)
TickBox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool
}

class Checkbox extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    controlled: PropTypes.bool,
    onChange: PropTypes.func
  }

  static defaultProps = {
    controlled: false,
    onChange: () => {}
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (prevState.controlled) {
      return {
        checked: nextProps.checked
      }
    }
    return null
  }

  constructor (props) {
    super(props)
    this.state = {
      checked: props.checked,
      controlled: props.controlled
    }
  }

  onClick = (e) => {
    const { onChange, name, checked, disabled } = this.props
    const { controlled } = this.state
    if (disabled) return
    if (controlled) {
      onChange(name, !checked)
    } else {
      this.setState({ checked: !this.state.checked }, onChange.bind(null, name, !this.state.checked))
    }
  }

  render () {
    const { className, name, disabled, children } = this.props
    const { checked } = this.state

    return (
      <CheckboxContainer className={className} checked={checked} disabled={disabled} onClick={this.onClick}>
        <HiddenInput id={name} name={name} checked={checked} disabled={disabled} />
        {children({ checked, disabled })}
      </CheckboxContainer>
    )
  }
}

Checkbox.Tick = TickBox

export default Checkbox
